/**
 * Watchlist Redux Slice
 */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [], // { exchange, token, tradingSymbol, ... }
};

const watchlistSlice = createSlice({
  name: 'watchlist',
  initialState,
  reducers: {
    addToWatchlist: (state, action) => {
      const exists = state.items.find(
        item => item.exchange === action.payload.exchange && 
                item.instrumentId === action.payload.instrumentId
      );
      if (!exists) {
        state.items.push(action.payload);
        console.log(`🔥 Redux ADD: ${action.payload.tradingSymbol} | Total items: ${state.items.length} | NFO items: ${state.items.filter(i => i.exchange === 'NFO').length}`);
        localStorage.setItem('watchlist', JSON.stringify(state.items));
      } else {
        console.log(`⚠️ Redux ADD SKIPPED: ${action.payload.tradingSymbol} already exists`);
      }
    },
    removeFromWatchlist: (state, action) => {
      const { exchange, instrumentId } = action.payload;
      const beforeCount = state.items.length;
      const nfoBeforeCount = state.items.filter(i => i.exchange === 'NFO').length;
      
      state.items = state.items.filter(
        item => !(item.exchange === exchange && item.instrumentId === instrumentId)
      );
      
      const afterCount = state.items.length;
      const nfoAfterCount = state.items.filter(i => i.exchange === 'NFO').length;
      
      console.log(`🔥 Redux REMOVE: ${action.payload.tradingSymbol || 'Unknown'} | Total: ${beforeCount}→${afterCount} | NFO: ${nfoBeforeCount}→${nfoAfterCount}`);
      localStorage.setItem('watchlist', JSON.stringify(state.items));
    },
    loadWatchlist: (state) => {
      const saved = localStorage.getItem('watchlist');
      if (saved) {
        const beforeCount = state.items.length;
        state.items = JSON.parse(saved);
        const afterCount = state.items.length;
        console.log(`🔥 Redux LOAD: ${beforeCount}→${afterCount} items | NFO: ${state.items.filter(i => i.exchange === 'NFO').length}`);
      }
    },
    clearWatchlist: (state) => {
      console.log(`🔥 Redux CLEAR: ${state.items.length} items cleared`);
      state.items = [];
      localStorage.removeItem('watchlist');
    },
  },
});

export const {
  addToWatchlist,
  removeFromWatchlist,
  loadWatchlist,
  clearWatchlist,
} = watchlistSlice.actions;

export default watchlistSlice.reducer;
